export enum EmailTemplates {
  WELCOME = 'welcomeEmail',
  CAS_BYPASS_WELCOME = 'casBypassWelcome',
  STUDENT_DETAILS = 'studentResumePersonalInfo',
  HISTORY = 'studentResumeHistory',
  FINANCE = 'studentResumeFinancePlan',
  OUTSTANDING_DOCUMENTS = 'resumeOutstandingDocumentsEmail',
  OUTSTANDING_FOLLOWUP_DOCUMENTS = 'resumeOutstandingFollowupDocumentsEmail',
  PRECAS_INTERVIEW = 'studentResumeQuestionnaire',
  INTERVIEWS = 'studentResumeInterview',
  DEPOSIT = 'studentResumeDeposit',
  PASSPORT = 'studentResumePassport',
  COURSE_DELETION_REPORT = 'courseDeletionReportEmail',
  PATHWAY_REVIEW_STUDENTS_FOR_UNI_REPORT = 'pathwayReviewStudentsForUniReportEmail',
  CONFLICT_EXCEPTION_REPORT = 'conflictExceptionReportEmail',
  ARRIVAL_1 = 'arrivalEmail1',
  ARRIVAL_2 = 'arrivalEmail2',
  ARRIVAL_3 = 'arrivalEmail3',
  ARRIVAL_4 = 'arrivalEmail4',
  VISA_1 = 'studentStatusVisa1',
  VISA_1_LATE = 'studentStatusVisa1Late',
  VISA_2 = 'studentStatusVisa2',
  VISA_2_LATE = 'studentStatusVisa2Late',
  READY_FOR_CAS = 'readyForCASEmail',
  DEFERRAL = 'deferralEmail',
  NEW_INTERVIEWS = 'studentResumeInterviewNew'
}

export enum ApplicantReminderEmailTemplates {
  VERIFY_REMINDER_1 = 'applicantVerifyReminder1',
  VERIFY_REMINDER_2 = 'applicantVerifyReminder2',
  VERIFY_REMINDER_3 = 'applicantVerifyReminder3',
  VERIFY_REMINDER_4 = 'applicantVerifyReminder4',

  REGISTER_INTEREST_1 = 'applicantRegisterInterestReminder1',
  REGISTER_INTEREST_2 = 'applicantRegisterInterestReminder2',
  REGISTER_INTEREST_3 = 'applicantRegisterInterestReminder3',
  REGISTER_INTEREST_4 = 'applicantRegisterInterestReminder4',

  START_APPLICATION_1 = 'applicantStartApplicationReminder1',
  START_APPLICATION_2 = 'applicantStartApplicationReminder2',
  START_APPLICATION_3 = 'applicantStartApplicationReminder3',
  START_APPLICATION_4 = 'applicantStartApplicationReminder4',

  CONTINUE_APPLICATION_1 = 'applicantContinueApplicationReminder1',
  CONTINUE_APPLICATION_2 = 'applicantContinueApplicationReminder2',
  CONTINUE_APPLICATION_3 = 'applicantContinueApplicationReminder3',
  CONTINUE_APPLICATION_4 = 'applicantContinueApplicationReminder4',

  SUBMIT_APPLICATION_1 = 'applicantSubmitApplicationReminder1',
  SUBMIT_APPLICATION_2 = 'applicantSubmitApplicationReminder2',
  SUBMIT_APPLICATION_3 = 'applicantSubmitApplicationReminder3',
  SUBMIT_APPLICATION_4 = 'applicantSubmitApplicationReminder4',

  UPDATE_STUDY_1 = 'applicantUpdateStudy1',
  UPDATE_STUDY_2 = 'applicantUpdateStudy2',
  UPDATE_STUDY_3 = 'applicantUpdateStudy3',
  UPDATE_STUDY_4 = 'applicantUpdateStudy4',

  ACCEPT_YOUR_OFFER_1 = 'applicantAcceptOfferReminder1',
  ACCEPT_YOUR_OFFER_2 = 'applicantAcceptOfferReminder2',

  SATISFY_OFFER_CONDITION_1 = 'applicantSatisfyOfferConditionReminder1',
  SATISFY_OFFER_CONDITION_2 = 'applicantSatisfyOfferConditionReminder2',

  CONFIRM_PAYMENT_1 = 'applicantConfirmPaymentReminder1',
  CONFIRM_PAYMENT_2 = 'applicantConfirmPaymentReminder2'
}

// This mapping will only use to reduce to duplicate {template}.html files
export const applicantTemplateToEmailTemplateMap: Record<ApplicantReminderEmailTemplates, string> = {
  [ApplicantReminderEmailTemplates.REGISTER_INTEREST_1]: 'applicantRegisterInterestReminder',
  [ApplicantReminderEmailTemplates.REGISTER_INTEREST_2]: 'applicantRegisterInterestReminder',
  [ApplicantReminderEmailTemplates.REGISTER_INTEREST_3]: 'applicantRegisterInterestReminder',
  [ApplicantReminderEmailTemplates.REGISTER_INTEREST_4]: 'applicantRegisterInterestReminder',
  [ApplicantReminderEmailTemplates.VERIFY_REMINDER_1]: 'applicantVerifyReminder1',
  [ApplicantReminderEmailTemplates.VERIFY_REMINDER_2]: 'applicantVerifyReminder2',
  [ApplicantReminderEmailTemplates.VERIFY_REMINDER_3]: 'applicantVerifyReminder3',
  [ApplicantReminderEmailTemplates.VERIFY_REMINDER_4]: 'applicantVerifyReminder4',
  [ApplicantReminderEmailTemplates.START_APPLICATION_1]: 'applicantStartApplicationReminder',
  [ApplicantReminderEmailTemplates.START_APPLICATION_2]: 'applicantStartApplicationReminder',
  [ApplicantReminderEmailTemplates.START_APPLICATION_3]: 'applicantStartApplicationReminder',
  [ApplicantReminderEmailTemplates.START_APPLICATION_4]: 'applicantStartApplicationReminder',
  [ApplicantReminderEmailTemplates.CONTINUE_APPLICATION_1]: 'applicantContinueApplicationReminder',
  [ApplicantReminderEmailTemplates.CONTINUE_APPLICATION_2]: 'applicantContinueApplicationReminder',
  [ApplicantReminderEmailTemplates.CONTINUE_APPLICATION_3]: 'applicantContinueApplicationReminder',
  [ApplicantReminderEmailTemplates.CONTINUE_APPLICATION_4]: 'applicantContinueApplicationReminder',
  [ApplicantReminderEmailTemplates.SUBMIT_APPLICATION_1]: 'applicantSubmitApplicationReminder',
  [ApplicantReminderEmailTemplates.SUBMIT_APPLICATION_2]: 'applicantSubmitApplicationReminder',
  [ApplicantReminderEmailTemplates.SUBMIT_APPLICATION_3]: 'applicantSubmitApplicationReminder',
  [ApplicantReminderEmailTemplates.SUBMIT_APPLICATION_4]: 'applicantSubmitApplicationReminder',
  [ApplicantReminderEmailTemplates.UPDATE_STUDY_1]: 'applicantUpdateStudyPlansReminder',
  [ApplicantReminderEmailTemplates.UPDATE_STUDY_2]: 'applicantUpdateStudyPlansReminder',
  [ApplicantReminderEmailTemplates.UPDATE_STUDY_3]: 'applicantUpdateStudyPlansReminder',
  [ApplicantReminderEmailTemplates.UPDATE_STUDY_4]: 'applicantUpdateStudyPlansReminder',
  [ApplicantReminderEmailTemplates.ACCEPT_YOUR_OFFER_1]: 'applicantAcceptOfferReminder',
  [ApplicantReminderEmailTemplates.ACCEPT_YOUR_OFFER_2]: 'applicantAcceptOfferReminder',
  [ApplicantReminderEmailTemplates.CONFIRM_PAYMENT_1]: 'applicantConfirmPaymentReminder',
  [ApplicantReminderEmailTemplates.CONFIRM_PAYMENT_2]: 'applicantConfirmPaymentReminder',
  [ApplicantReminderEmailTemplates.SATISFY_OFFER_CONDITION_1]: 'applicantSatisfyOfferConditionReminder',
  [ApplicantReminderEmailTemplates.SATISFY_OFFER_CONDITION_2]: 'applicantSatisfyOfferConditionReminder'
};

export * from './reminder-notification';
